import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you are looking for does not exist. Return to TRED-EX AI homepage to explore our enterprise AI products."
        canonical="/404"
        noIndex
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Page Not Found',
          description: 'The page you are looking for does not exist.',
        }}
      />
      <Navbar />
      <div className="legal-page">
        <div className="legal-page-content" style={{ textAlign: 'center', padding: '80px 20px' }}>
          <h1 style={{ fontSize: '6rem', margin: 0 }}>404</h1>
          <h2 style={{ marginTop: 0 }}>Page Not Found</h2>
          <p style={{ color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto 24px' }}>
            The page you are looking for doesn't exist or has been moved. Let's get you back on track.
          </p>
          <Link to="/" className="btn btn-primary btn-lg">
            <i className="fas fa-home"></i> Back to Home
          </Link>
          <div style={{ marginTop: '40px', display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/terms" style={{ color: 'var(--text-muted)' }}>Terms of Service</Link>
            <Link to="/privacy" style={{ color: 'var(--text-muted)' }}>Privacy Policy</Link>
            <Link to="/refund" style={{ color: 'var(--text-muted)' }}>Refund Policy</Link>
            <Link to="/disclaimer" style={{ color: 'var(--text-muted)' }}>Disclaimer</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
